// ONYX-CUSTOM: markets selector dropdown; follows the entry link instead of posting the localization form
// Loaded as a module so the several renders (header, footer, topbar) run it once. Module scripts
// run after theme.js (defer, earlier in the document), so `localization-form` is defined here.
const LocalizationForm = customElements.get('localization-form');

if (LocalizationForm && !customElements.get('onyx-markets-selector')) {
  class OnyxMarketsSelector extends LocalizationForm {
    // Unique URL so the browser cannot reuse a cached page of the market the visitor came from.
    onItemClick(event) {
      event.preventDefault();
      const url = new URL(event.currentTarget.href);
      url.searchParams.set('_cb', Date.now());
      window.location.assign(url.toString());
    }
  }

  customElements.define('onyx-markets-selector', OnyxMarketsSelector);
}

const currentUrl = new URL(window.location.href);
if (currentUrl.searchParams.has('_cb')) {
  currentUrl.searchParams.delete('_cb');
  history.replaceState(history.state, '', currentUrl.toString());
}
